var $ = require('jquery');

$(function () {
    // On Document Ready, look for any validation errors. If found, scroll them into view
    var firstError = document.querySelector('.input-validation-error');
    if (firstError) {
        firstError.scrollIntoView();
    }

    $('.registration-form__body__submit').on('click', function (e) {
        e.preventDefault();
        var formNode = $(this).closest("form");
        var formId = formNode.attr("formid");
        
        if ($('.mtcaptcha[data-formid="' + formId + '"]').length) {
            let checkCaptcha = new Promise((resolve, reject) => {
                let mtcaptchaToken = mtcaptcha.getVerifiedToken();
                if (mtcaptchaToken.length === 0) {
                    reject(false);
                } else {
                    $.ajax(
                    {
                        url: "/api/Sitecore/MTCaptchaValidation/MTCaptchaValidation",
                        type: "POST",
                        context: this,
                        data: { token: mtcaptchaToken },
                        success: function (data) {
                            resolve(data);
                        },
                        error: function (data) {
                            reject(false);
                        }
                    });
                }
            });
            //first check captcha, then check the rest
            checkCaptcha.then(function () {
                formNode.submit();
            }).catch((rejection) => {
                formNode.find('.form__field--error').show().parent().addClass('form__field--has-error');                
            });
        } else {
            formNode.submit();
        }
    });

    $('form').keyup(function (event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            $(this).find(".registration-form__body__submit").click();
        }
    });
});